$(document).on('ajax:success', '.load-account-details, .load-bank-product-details', function (event) {
  var data = event.detail[0];
  $(this).closest('.load-account-details-wrapper').find('.togglable').prepend(data.html)
  $(this).removeAttr('data-remote').removeAttr('href')
  $(this).trigger('click');
});
